// extracted by css-extract-rspack-plugin
export default {"gridColumns":"_c03d2ebd"};